import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { Store, Bike, ArrowRight, ShoppingBag } from 'lucide-react';
import Logo from '../../components/Logo';
import { useFeatureFlag } from '../../contexts/FeatureFlagContext';

const Signup: React.FC = () => {
  const navigate = useNavigate();
  const storesEnabled = useFeatureFlag('stores');
  const deliveriesEnabled = useFeatureFlag('deliveries');

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={10} lg={9}>
          <div className="text-center mb-5">
            <Logo size={120} variant="stacked" tagline />
            <h1 className="h3 fw-bold mt-3 mb-2">Join ProvisionMart</h1>
            <p className="text-muted">Choose how you'd like to get started</p>
          </div>

          {(storesEnabled || deliveriesEnabled) && (
            <Row className="g-4">
              {storesEnabled && (
                <Col md={deliveriesEnabled ? 6 : 12}>
                  <Card
                    className="h-100 border-0 shadow-sm"
                    style={{ cursor: 'pointer', transition: 'transform .15s' }}
                    onClick={() => navigate('/register/store')}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-4px)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                  >
                    <Card.Body className="p-4 text-center">
                      <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 72, height: 72 }}>
                        <Store size={36} className="text-success" />
                      </div>
                      <h4 className="fw-bold mb-2">Register a Store</h4>
                      <p className="text-muted small mb-3">
                        Sell your groceries, food or essentials to customers nearby. Get paid 95% directly to your UPI on every order.
                      </p>
                      <Button variant="success" className="fw-bold">
                        Register as Store <ArrowRight size={16} className="ms-1" />
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              )}

              {deliveriesEnabled && (
                <Col md={storesEnabled ? 6 : 12}>
                  <Card
                    className="h-100 border-0 shadow-sm"
                    style={{ cursor: 'pointer', transition: 'transform .15s' }}
                    onClick={() => navigate('/register/delivery')}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-4px)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                  >
                    <Card.Body className="p-4 text-center">
                      <div className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 72, height: 72 }}>
                        <Bike size={36} className="text-warning" />
                      </div>
                      <h4 className="fw-bold mb-2">Become a Delivery Partner</h4>
                      <p className="text-muted small mb-3">
                        Earn flexible income delivering orders in your area. KYC verification + Aadhaar + vehicle details required.
                      </p>
                      <Button variant="warning" className="fw-bold text-white">
                        Apply as Delivery Partner <ArrowRight size={16} className="ms-1" />
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              )}
            </Row>
          )}

          <Card className="border-0 shadow-sm mt-4">
            <Card.Body className="p-4 text-center">
              <ShoppingBag size={28} className="text-success mb-2" />
              <h5 className="fw-bold mb-1">Just want to shop?</h5>
              <p className="text-muted small mb-3">
                No signup needed. Enter your email or phone, verify with OTP, and start ordering. Complete your profile any time later.
              </p>
              <Link to="/login" className="btn btn-outline-success fw-bold">
                Continue with OTP →
              </Link>
            </Card.Body>
          </Card>

          <p className="text-center text-muted mt-4 mb-0 small">
            Already have an account?{' '}
            <Link to="/login" className="fw-bold text-success text-decoration-none">Sign in</Link>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Signup;
